/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { useShowError } from "~/components/Error/useShowError";
import { ClearButton } from "~/components/InlineEdit/ClearButton";
import { showSuccess } from "~/components/Toast";
import {
  AssignmentRule,
  AssignmentRuleRouteParams,
} from "~/models/assignmentRule";
import { useAxios, generateActionSuccessText } from "~/tools";

type AssignmentRuleServiceLevelClearProps = {
  assignmentRule: AssignmentRule;
  refetch: () => Promise<void>;
};

export function AssignmentRuleServiceLevelClear({
  assignmentRule,
  refetch,
}: AssignmentRuleServiceLevelClearProps) {
  const {
    customerId,
    assignmentRuleId,
  } = useParams<AssignmentRuleRouteParams>();
  const { showError } = useShowError();
  const { Axios } = useAxios();

  const [isSubmittingLoading, setIsSubmittingLoading] = React.useState(false);

  const handleClear = async () => {
    setIsSubmittingLoading(true);
    const organizeValues = {
      ...assignmentRule,
      attachedServiceLevel: null,
    };
    try {
      await Axios().put(
        `/customers/${customerId}/assignmentRules/${assignmentRuleId}`,
        organizeValues
      );
      refetch();
      showSuccess(generateActionSuccessText("Service Level")()("cleared")());
    } catch (e) {
      showError(e?.response);
    } finally {
      setIsSubmittingLoading(false);
    }
  };

  return <ClearButton onClick={handleClear} isLoading={isSubmittingLoading} />;
}
